module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_8017.d7344754.png";